import React from 'react';
import _ from 'lodash';
import PropTypes from 'prop-types';
import InputDisplayTemplate from '../../components/InputDisplayTemplate'

const StudentInformation = ({ studentInfo }) => {
  return (
    <>
      <div className="row d-flex  mb-1 p-3" style={{height:'500px', overflowY:'scroll', }}>
        <h3 className="cms-text-primary font-weight-bold py-2">Program</h3>
        <div className="col-12 mb-3 p-1 form-wrapper-alternate-bg">
          <InputDisplayTemplate title="Direkta Ayuda" dataItem={_.get(studentInfo, 'attributes.with_direkta_ayuda') ? 'Yes' : 'No' || '- -'} />
          <InputDisplayTemplate title="Libre Sakay" dataItem={_.get(studentInfo, 'attributes.with_libre_sakay') ? 'Yes' : 'No' || '- -'} />
        </div>
        <h3 className="cms-text-primary font-weight-bold py-2">Personal Information</h3>
        <div className="col-12 mb-3 p-1 form-wrapper-alternate-bg">
          <InputDisplayTemplate title="Last Name" dataItem={_.get(studentInfo, 'attributes.last_name') || '- -'} />
          <InputDisplayTemplate title="First Name" dataItem={_.get(studentInfo, 'attributes.first_name') || '- -'} />
          <InputDisplayTemplate title="Middle Name" dataItem={(_.get(studentInfo, 'attributes.middle_name'))  || '- -'} />
          <InputDisplayTemplate title="Suffix" dataItem={_.get(studentInfo, 'attributes.extension_name') || '- -'} />
          <InputDisplayTemplate title="Gender" dataItem={_.get(studentInfo, 'attributes.gender') || '- -'} />
          <InputDisplayTemplate title="Date of Birth" dataItem={_.get(studentInfo, 'attributes.birth_date') || '- -'} />
          <InputDisplayTemplate title="Age" dataItem={(_.get(studentInfo, 'attributes.age'))  || '- -'} />
        </div>
        <h3 className="col-12 cms-text-primary font-weight-bold py-2">Contact Information</h3>
        <div className="col-12 mb-3 p-1 form-wrapper-alternate-bg">
          <InputDisplayTemplate title="Email Address" dataItem={(_.get(studentInfo, 'attributes.email'))  || '- -'} />
          <InputDisplayTemplate title="Mobile Number" dataItem={(_.get(studentInfo, 'attributes.mobile_number')) || '- -'} />
          <InputDisplayTemplate title="Telephone Number" dataItem={_.get(studentInfo, 'attributes.telephone_number') || '- -'} />
        </div>
        <h3 className="col-12 cms-text-primary font-weight-bold py-2">Address</h3>
        <div className="col-12 mb-3 p-1 form-wrapper-alternate-bg">
          <InputDisplayTemplate title="Region" dataItem={_.get(studentInfo, 'attributes.region_name') || '- -'} />
          <InputDisplayTemplate title="Province" dataItem={_.get(studentInfo, 'attributes.province_name') || '- -'} />
          <InputDisplayTemplate title="Municipality" dataItem={_.get(studentInfo, 'attributes.municipality_name') || '- -'} />
          <InputDisplayTemplate title="Barangay" dataItem={_.get(studentInfo, 'attributes.barangay_name') || '- -'} />
          <InputDisplayTemplate title="Zone" dataItem={_.get(studentInfo, 'attributes.zone') || '- -'} />
          <InputDisplayTemplate title="Unit No. / House No. / Street Name" dataItem={_.get(studentInfo, 'attributes.address') || '- -'} />
        </div>
        
        <h3 className="col-12 cms-text-primary font-weight-bold py-2">Place of Birth</h3>
        <div className="col-12 mb-3 p-1 form-wrapper-alternate-bg">
          <InputDisplayTemplate title="Region" dataItem={_.get(studentInfo, 'attributes.place_of_birth_region_name') || '- -'} />
          <InputDisplayTemplate title="Province" dataItem={_.get(studentInfo, 'attributes.place_of_birth_province_name') || '- -'} />
          <InputDisplayTemplate title="Municipality" dataItem={_.get(studentInfo, 'attributes.place_of_birth_municipality_name') || '- -'} />
        </div>
        <h2 className="col-12 cms-text-primary font-weight-bold pb-2 pt-3">Family Information</h2>

        <h3 className="col-12 cms-text-primary font-weight-bold py-2">Mothers Maiden Name</h3>
        <div className="col-12 mb-3 p-1 form-wrapper-alternate-bg">
          <InputDisplayTemplate title="Last Name" dataItem={_.get(studentInfo, 'attributes.mother_maiden_last_name') || '- -'} />
          <InputDisplayTemplate title="First Name" dataItem={_.get(studentInfo, 'attributes.mother_maiden_first_name') || '- -'} />
          <InputDisplayTemplate title="Middle Name" dataItem={(_.get(studentInfo, 'attributes.mother_maiden_middle_name')) || '- -'} />
        </div>

        <h3 className="col-12 cms-text-primary font-weight-bold py-2">Fathers Name</h3>
        <div className="col-12 mb-3 p-1 form-wrapper-alternate-bg">
          <InputDisplayTemplate title="Last Name" dataItem={_.get(studentInfo, 'attributes.father_last_name') || '- -'} />
          <InputDisplayTemplate title="First Name" dataItem={_.get(studentInfo, 'attributes.father_first_name') || '- -'} />
          <InputDisplayTemplate title="Middle Name" dataItem={(_.get(studentInfo, 'attributes.father_middle_name'))  || '- -'} />
        </div>

        <h3 className="col-12 cms-text-primary font-weight-bold py-2">Spouse Name</h3>
        <div className="col-12 mb-3 p-1 form-wrapper-alternate-bg">
          <InputDisplayTemplate title="Last Name" dataItem={_.get(studentInfo, 'attributes.spouse_last_name') || '- -'} />
          <InputDisplayTemplate title="First Name" dataItem={_.get(studentInfo, 'attributes.spouse_first_name') || '- -'} />
          <InputDisplayTemplate title="Middle Name" dataItem={(_.get(studentInfo, 'attributes.spouse_middle_name'))  || '- -'} />
        </div>

        <h3 className="col-12 cms-text-primary font-weight-bold py-2">Identity Information</h3>
        <div className="col-12 mb-3 p-1 form-wrapper-alternate-bg">
          <InputDisplayTemplate title="Height" dataItem={_.get(studentInfo, 'attributes.height') || '- -'} />
          <InputDisplayTemplate title="Weight" dataItem={_.get(studentInfo, 'attributes.weight') || '- -'} />
          <InputDisplayTemplate title="Complexion" dataItem={(_.get(studentInfo, 'attributes.complexion'))  || '- -'} />
          <InputDisplayTemplate title="Country of Citizenship" dataItem={(_.get(studentInfo, 'attributes.citizenship_code'))  || '- -'} />
        </div>

        <h3 className="col-12 cms-text-primary font-weight-bold py-2">Educational Information</h3>
        <div className="col-12 mb-3 p-1 form-wrapper-alternate-bg">
          <InputDisplayTemplate title="Highest Educational Attainment" dataItem={_.get(studentInfo, 'attributes.educational_attainment') || '- -'} />
          <InputDisplayTemplate title="Institution" dataItem={_.get(studentInfo, 'attributes.institution_name') || '- -'} />
          <InputDisplayTemplate title="Grade / Year" dataItem={_.get(studentInfo, 'attributes.grade_level_name') || '- -'} />
        </div>

        <h3 className="col-12 cms-text-primary font-weight-bold py-2">Valid ID</h3>
        <div className="col-12 mb-3 p-1 form-wrapper-alternate-bg">
          <InputDisplayTemplate title="Type of Valid ID" dataItem={_.get(studentInfo, 'attributes.id_type') || '- -'} />
          <InputDisplayTemplate title="Valid ID" dataItem={_.get(studentInfo, 'attributes.id_url') || '- -'} isImage />
        </div>
      </div>
    </>
  );
};

StudentInformation.propTypes = {
  studentInfo: PropTypes.instanceOf(Object).isRequired,
};

export default StudentInformation;
